<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="form">
                    <v-container py-0>
                        <v-layout wrap>            
                            <v-flex xs12 md12>
                                <v-select :readonly="true" :label="cboPais" :items="listaPais" return-object v-model="pais"
                                    item-value="id" item-text="nome" :no-data-text="cboPaisSemDados"
                                    required :rules="rules.pais"></v-select>
                            </v-flex>         

                            <v-flex xs12 md12>
                                <v-select :readonly="true" :label="cboEmpresa" :items="listaEmpresa" return-object v-model="empresa"
                                    item-value="id" item-text="nome" :no-data-text="cboEmpresaSemDados"
                                    required :rules="rules.empresa"></v-select>
                            </v-flex>          

                            <v-flex xs12 md12>
                                <v-select :readonly="true" :label="cboDivisao" :items="listaDivisao" return-object v-model="divisao"
                                    item-value="id" item-text="nome" :no-data-text="cboDivisaoSemDados"
                                    required :rules="rules.divisao"></v-select>
                            </v-flex>          

                            <v-flex xs12 md12>
                                <v-select :readonly="true" :label="cboLocalidade" :items="listaLocalidade" return-object v-model="localidade"
                                    item-value="id" item-text="nome" :no-data-text="cboLocalidadeSemDados"
                                    required :rules="rules.localidade"></v-select>
                            </v-flex>                      
                        </v-layout>
                    </v-container>         
                </v-form>                  
            </v-flex>            
        </v-layout>               
    </v-container>
</template>

<script>
import OnboardingConstantes from '@/constants/onboarding/parametrizacao'
import FormMixin from '@/mixin/form'
import StepMixin from './mixin'

import { mapGetters } from 'vuex'

export default {
    mixins: [ FormMixin, StepMixin ],     
    data () {
        return { 
            rules:{
                pais: [
                    val => {
                        if((val || null) == null)
                            return this.cboPaisObrigatorio;

                        return true;
                    }
                ],
                empresa: [
                    val => {
                        if((val || null) == null)
                            return this.cboEmpresaObrigatorio;

                        return true;
                    }
                ],
                divisao: [
                    val => {
                        if((val || null) == null)
                            return this.cboDivisaoObrigatorio;

                        return true;
                    }
                ],
                localidade: [
                    val => {
                        if((val || null) == null)
                            return this.cboLocalidadeObrigatorio;

                        return true;
                    }
                ]                                       
            },                 
        }
    },
    computed: {       
        ...mapGetters("app", ["getUserCountry"]),       
        cboPais(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.pais')            
        },
        cboPaisSemDados(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.nenhum-pais-encontrado')            
        },
        cboPaisObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.pais-obrigatorio')            
        },       
        listaPais(){
            if(this.value != null && this.value != undefined){
                if(this.value.pais == undefined || this.value.pais == null)
                    return [];

                return [ this.value.pais ];   
            }

            return [];
        },            
        pais:{
            get(){
                if(this.value != null && this.value != undefined){
                    if(this.value.pais == null || this.value.pais == undefined)
                        return null;

                    return this.value.pais;
                }

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.pais = value;            
                    
                    this.$emit("input", onboarding);
                }              
            }
        },  
        cboEmpresa(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.empresa')            
        },
        cboEmpresaSemDados(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.nenhuma-empresa-encontrada')            
        },
        cboEmpresaObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.empresa-obrigatorio')            
        },         
        listaEmpresa(){
            if(this.value != null && this.value != undefined){
                if(this.value.empresa == null || this.value.empresa == undefined)
                    return [];

                let empresa = this.$_.clone(this.value.empresa);
                empresa.nome = `${empresa.nome} (${empresa.codigoSuccessFactors})`;

                return [ empresa ];
            }

            return [];
        },        
        empresa:{
            get(){
                if(this.value != null && this.value != undefined)
                    return this.value.empresa;

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.empresa = value; 
                    
                    this.$emit("input", onboarding);
                }              
            }
        }, 
        cboDivisao(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.divisao')            
        },
        cboDivisaoSemDados(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.nenhuma-divisao-encontrada')            
        },
        cboDivisaoObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.divisao-obrigatorio')            
        },           
        listaDivisao(){
            if(this.value != null && this.value != undefined){
                if(this.value.divisao == null || this.value.divisao == undefined)
                    return [];

                let divisao = this.$_.clone(this.value.divisao);
                divisao.nome = `${divisao.nome} (${divisao.codigoSuccessFactors})`;

                return [ divisao ];
            }

            return [];
        },        
        divisao:{
            get(){
                if(this.value != null && this.value != undefined)
                    return this.value.divisao;

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.divisao = value; 
                    
                    this.$emit("input", onboarding);
                }              
            }
        },                 
        cboLocalidade(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.localidade')            
        },
        cboLocalidadeSemDados(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.nenhuma-localidade-encontrada')            
        },
        cboLocalidadeObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.localidade-obrigatorio')            
        },                              
        listaLocalidade(){
            if(this.value != null && this.value != undefined){
                if(this.value.localidade == null || this.value.localidade == undefined)
                    return [];

                let localidade = this.$_.clone(this.value.localidade);
                localidade.nome = `${localidade.nome} (${localidade.codigoSuccessFactors})`;

                return [ localidade ];
            }

            return [];
        },
        localidade:{
            get(){
                if(this.value != null && this.value != undefined)
                    return this.value.localidade;

                return null;
            },
            set(value){
                if(this.value != null && this.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.localidade = value; 
                    
                    this.$emit("input", onboarding);
                }              
            }
        },                                                   
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";

</style>
